exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\nNOTE:\nTHESE VARIABLES ARE HERE FOR THE SAKE OF COMPATIBILITY\nPLEASE USE THE ONES UNDER \"NEW NAMING\"\n*/\n\n/* NEW NAMING */\n\n/* families */\n\n/* size */\n\n/* General Indexes */\n\n/* Loading Layer */\n\n/* Component Indexes */\n\n/* Matching Pairs */\n\n/* Draw It */\n\n/* Global Transitions */\n\n.recaptcha_form__captcha--21UY2 {\n\tdisplay: flex;\n\tjustify-content: center;\n\tpadding: 10px 0;\n\tpadding-bottom: 0\n}\n\n.recaptcha_form__captcha-error--24kce {\n\t\tcolor: #f26c59;\n\t\tfont-family: 'avenirlightoblique', Helvetica, Arial, sans-serif;\n\t\tfont-size: 12px;\n\t\tline-height: 12px;\n\t\tmargin-top: 6px;\n\t\tpadding: 0 0 10px calc((100% - 304px) / 2);\n\t\ttext-align: left;\n\t\twhite-space: normal;\n\t}\n", ""]);

// exports
exports.locals = {
	"captcha": "recaptcha_form__captcha--21UY2",
	"captcha-error": "recaptcha_form__captcha-error--24kce"
};